import React,{Component} from "react";
import $ from 'jquery';
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import {setEmailConfigList} from '../../../store/actions/formBuilderActions'
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
// import HeaderTabs from "../../../Components/UI/HeaderTabs";
import MailLeftNav from './MailLeftNav';
import MailContent from './MailContent';
//import NewMail from './UI/NewMail';
import ComposeMail from '../ComposeMail';
import { callGET, callDELETE,callPOST } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {getActiveEmail, getUserInfo, setActiveEmail} from '../../../Utils/UserFunctions';
import AssignWindow from '../EmailTemplate/AssignWindow';
import {isSet,parameterizedURLAccessToken, updateImageSources} from '../../../Utils/CommonFunctions';
import { LinkContainer } from 'react-router-bootstrap';
import ConfirmBox from "../../../hoc/ConfirmBox";

const KeyCodes = {
    comma: 188,
    enter: 13,
};
// const delimiters = [KeyCodes.comma, KeyCodes.enter];



class EmailSetupContainer extends Component {
    

    constructor(props) {
        super(props);
        this.state = {
            is_system_user: false,
            modal: false,
            modalWindow: false,
            msgUnreadCnt : null,
            formFields:{
                data_id : {
                    title : "id",
                    field : "hidden",
                    placeHolder : "",
                    value : '',
                    error: '',
                    options : []
                },
                window_name : {
                    title : "Scope",
                    window_name_label: "",
                    field : "select",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control mandatory',
                    value : '',
                    error: '',
                    disabled:false,
                    options : []
                },
                mail_from : {
                    title : "Mail From",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 border_bottom',
                    value : 'test@gmail.com',
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_to : {
                    title : "Mail To",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 newMail_custom',
                    value : [],
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_cc : {
                    title : "Mail CC",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 newMail_custom',
                    value : [],
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_bcc : {
                    title : "Mail BCC",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 border_bottom',
                    value : [],
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_reply_to : {
                    title : "Reply To",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 border_bottom',
                    value : '',
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_subject : {
                    title : "Mail Subject",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 newMail_custom',
                    value : '',
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_template : {
                    title : "Mail Template",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 newMail_custom',
                    value : '',
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_body : {
                    title : "Mail Body",                
                    field : "text",
                    required : false,
                    placeHolder : "",
                    classname : 'form-control no-bd pl-0 border_bottom',
                    value : '',
                    error: '',
                    disabled:false,
                    options : []    
                },
                mail_attachments:[]            
            },
            mail_templates: [],
            toInputValue: '',
            toUsers: [],
            ccInputValue: '',
            ccUsers: [],
            suggestions:[],
            activeUser:null,
            activeIndex:null,
            ccShow: false,
            triggerEffect: false,
            emailName: this.props.match.params.emailName,
            pageType: 'Listing',
            windowId: (this.props.match.params.windowId!==undefined) ? this.props.match.params.windowId : '',
            formId: (this.props.match.params.formId!==undefined) ? this.props.match.params.formId : '',
            messageGroupId: (this.props.match.params.messageGroupId!==undefined) ? this.props.match.params.messageGroupId : '',
            isParamWindow: (this.props.match.params.windowId!==undefined) ? true : false,
            tableRecords:{            
                selectedRows:[],
                tableHead:[],
                tableData:[],
                pagination:{
                    page:0,
                    orderBy:'createdAt',
                    perPage:10,
                    direction:true,
                    totalRecords:0,
                    search:'',
                    listId : {
                        value : ''
                    }
                },
                isSelectAll:false
            },
            files: [],
            windowTags: [],
            mailData: '',
            isComposeMail:false,
            isDraft:false,
            isReplyTo:false,
            replyToData:null,
            isReplyToMail:false,
            emailConfigId:'',
            emailConfigName:'',
            emailConfigSearch:'',
            isFilterOpen:false,
            showDetailedMessage:[],
            currentMailRowId: '',
            inboxType:'All',
            isDataLoading: false,
            isMobileWebView:false,
            isMobileWebMenu:false,
            isMobileWebMessageView:false,
            importantHandleArr:[],
            replyMessageClose:false,
            isConfirmBoxOpen : false,
        }
    }

    /********** Email Web Mobile View *************/
    componentDidMount = () => {
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
    }

    updateDimensions = ()=>{
        if ($(window).width() < 768) {
            //console.log('window min')
            this.setState({isMobileWebView:true, isMobileWebMenu:this.state.isMobileWebMenu,isMobileWebMessageView:this.state.isMobileWebMessageView})
            //$('#splitView_sidebar').addClass('active');
        } else {
            //$('#splitView_sidebar').removeClass('active');
            //console.log('window max')
            this.setState({isMobileWebView:false, isMobileWebMenu:false,isMobileWebMessageView:false})
        }
    }

    toggleMobileWebMenu = () => {
        //console.log('toggleMobileWebMenu')
        this.setState({isMobileWebMenu:!this.state.isMobileWebMenu})
    }

    toggleMobileWebMessageView = () => {
        //console.log('toggleMobileWebMenu')
        this.setState({isMobileWebMessageView:!this.state.isMobileWebMessageView})
    }
    /********** Email Web Mobile View *************/

    

    componentWillMount = () => {        
        // this.emailMessageList(this.state.tableRecords.pagination);  
        console.log(this.state.emailName, 'emailName')
        //window.addEventListener('scroll', this.loadMore());
        //console.log(this.props.match.params.messageGroupId, 'this.props.match.params.messageGroupId')
        this.emailConfigList();
    } 

    componentDidUpdate = () => {
        //console.log('ssss')
    }   
    
    composeMailHandler = () => {
      this.setState({isComposeMail:!this.state.isComposeMail, isDraft:false})
    }

    replyToMailHandler = (emailData,isReplyAll=false) => {      
      let emailConfigName = "";
      const {emailConfigList}= this.props;
      if(emailConfigList && emailData && emailData.email_config_id && emailData.email_config_id!=='') {
        emailConfigList.map(configItem => {
            if(configItem.id === emailData.email_config_id) {
                emailConfigName = configItem.user_name;
            }
        })
      }
      emailData.emailConfigName = emailConfigName;
      emailData.isReplyAll = isReplyAll;
      // console.log(emailData);
      console.log('replyToMailHandler state',this.state.isReplyToMail)
      this.setState({isReplyToMail:!this.state.isReplyToMail, isDraft:false, isReplyTo:true,replyToData:emailData, replyMessageClose:false})
    }

    replyToMailHandlerNull = (emailData={}) => {
      this.setState({isReplyToMail:false, isDraft:false, isReplyTo:false,replyToData:emailData})
    }

    toggleFilter = () => {
        this.setState({isFilterOpen:!this.state.isFilterOpen, emailConfigSearch: ''});
    }

    replyToMailHandlerCallback = (emailPage,emailData) => {
      // console.log(emailPage,emailData);
      this.setState({isReplyToMail:false, isDraft:false, isReplyTo:true,replyToData:null})
      this.messageClickHandler(this.state.emailName, emailData)
    }

    emailConfigList = (isFilter="no") => {
        let searchParam='';
        let emailConfigSearch = this.state.emailConfigSearch;
        if(emailConfigSearch!==''){
            searchParam = "?search="+emailConfigSearch
        }
        let APIURL = 'email/config/search'+searchParam;
        callGET(APIURL)                                     
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data!==null & response.data.length > 0){

                        let defaultId = response.data[0].id;
                        let defaultName = response.data[0].user_name;
                        response.data.map((item,ind) => {
                            if(item.default === true) {
                                defaultId = item.id;
                                defaultName = item.user_name;
                            }
                        })
                        // console.log(defaultId);

                        const updateState = {...this.state}
                        this.props.setEmailConfigList(response.data)
                        if(isFilter === 'no'){
                            let activeEmail = getActiveEmail();
                            if(activeEmail!=null){
                                updateState.emailConfigId = activeEmail.id;
                                updateState.emailConfigName = activeEmail.name;
                            }else{
                                updateState.emailConfigId = defaultId;
                                updateState.emailConfigName = defaultName;
                            }
                            updateState.isDataLoading=false;    
                        }
                        
                        if(this.state.messageGroupId!==undefined && this.state.messageGroupId!==''){
                            updateState.currentMailRowId=this.state.messageGroupId; 
                            updateState.inboxType = 'Unread'; 
                        }
                            
                        this.setState(updateState);
                        
                        if(isFilter === 'no'){
                            setTimeout(() => {
                                this.emailMessageList(this.state.tableRecords.pagination);                               
                            },500)
                        }
                    }else{
                        const updateState = {...this.state} 
                        updateState.isDataLoading=true;   
                        this.setState(updateState);   
                    }
                }
            }           

        },(error) => {
            console.log(error);
        })
    }

    /********** Email Message Listing************/
    callEmailPage = (emailPage, scroll="no") => {
        //console.log(this.state.emailName,'callEmailPage==',emailPage)
        const updateState = { ...this.state };        
        updateState.emailName= emailPage;
        //updateState.tableRecords.selectedRows = [];
        //updateState.tableRecords.isSelectAll = false;        
        updateState.isParamWindow = false;
        updateState.pageType= 'Listing';  
        //console.log(this.props.match.params.messageGroupId, 'this.props.match.params.messageGroupId')
        
        updateState.files = [];
        if(scroll === 'no'){
            updateState.tableRecords.selectedRows = []
            updateState.tableRecords.tableData = []
            updateState.tableRecords.tableHead = []
            updateState.tableRecords.pagination.page = 0;
            updateState.tableRecords.pagination.totalRecords = 0; 
            updateState.mailData = ''; 
            updateState.isDataLoading=false            
            updateState.tableRecords.isSelectAll = false; 
            if(this.props.match.params.messageGroupId!==undefined && this.props.match.params.messageGroupId!==''){ 
                updateState.messageGroupId='';
                updateState.currentMailRowId=this.props.match.params.messageGroupId;
                updateState.inboxType = 'Unread'

                let defaultUserConfigID = getUserInfo().data.default_emailconfig_id;
                const {emailConfigList} =this.props;
                if(defaultUserConfigID!=='' && emailConfigList.length>0){
                    let findRowIndex = emailConfigList.findIndex(obj => defaultUserConfigID);                    
                    updateState['emailConfigId'] = emailConfigList[findRowIndex].id;   
                    updateState['emailConfigName'] = emailConfigList[findRowIndex].user_name;   
                }
                

            }else{
                updateState.currentMailRowId = '';
                updateState.inboxType = 'All'    
            }
             
        }else{
            updateState.isDataLoading=true
        }
        
        this.setState(updateState);        
        this.replyToMailHandlerNull();        
        this.emailMessageList(this.state.tableRecords.pagination);    

    }

    emailMessageList = (pagination, refresh="false") => {
        const page = pagination.page; 
        const orderBy = pagination.orderBy; 
        const perPage = pagination.perPage; 
        //const direction = pagination.direction; 
        const direction = false; 
        const search = pagination.search;
        const emailPage = this.state.emailName;
        const emailConfigId = this.state.emailConfigId;

        this.setState({
            tableRecords:{
              ...this.state.tableRecords,
              pagination:pagination
            },
            pageType: 'Listing',
            //isDataLoading: false            
            //mailData: ''
        });

        let messagePlaceholder = 'OUTBOX';
        if(emailPage === 'inbox'){
            messagePlaceholder = '&messagePlaceholder=INBOX';
            this.getInboxMsgCount();
        }

        if(emailPage === 'outbox'){
            messagePlaceholder = '&messagePlaceholder=OUTBOX';
        }

        if(emailPage === 'drafts'){
            messagePlaceholder = '&messagePlaceholder=DRAFT';
            this.getInboxMsgCount();
        }

        
        this.props.Loader(true);

        let extraParam = '';
        if(emailPage === 'important'){
            messagePlaceholder = '';
            extraParam = '&important=true';
        }

        if(emailPage === 'trash'){
            messagePlaceholder = '';
            extraParam = '&trash=true';
        }

        // if(emailPage === 'inbox'){
        //     messagePlaceholder = 'INBOX';
        // }

        if(emailPage === 'archive'){
            messagePlaceholder = '';
            extraParam = '&archive=true';
        }
        // Email header notification click
        if(this.props.match.params.messageGroupId!==undefined && this.props.match.params.messageGroupId!==''){
            extraParam = '&un_read_only=true';    
        }        
        const url = "email/message/search";
        let queryString = '';
        queryString = '?refresh='+refresh+'&emailConfigIds='+emailConfigId+'&search='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&sortAsc='+direction+extraParam+messagePlaceholder;
        callGET(url+queryString)
        .then(res => {
            //if(loadtype!==0) { this.props.Loader(); }
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    if(response.data){
                        this.props.Loader(false);

                        let nextPage = parseInt(response.data.pageable.page_number) + parseInt(1);
                        let updateTableData = this.state.tableRecords.tableData;
                        let selectedRowsArr = [...this.state.tableRecords.selectedRows];
                        let isSelectAllVal = this.state.tableRecords.isSelectAll;
                        if(updateTableData.data){
                            updateTableData = this.state.tableRecords.tableData.data;  
                        }else{
                            updateTableData = this.state.tableRecords.tableData;   
                        }

                        if(page === 0){updateTableData = []}

                        let itemDataNew = response.data.content;
                        if(itemDataNew.length > 0) {
                            //let updateTableData = [];
                            itemDataNew.map((item,index)=>{                             
                                let ss = { 
                                    rowId: item.id,
                                    message_date: item.created_at,
                                    subject: item.subject,
                                    body: item.body,
                                    message_group_id: item.message_group_id,
                                    itemData:item 
                                }
                                updateTableData.push(ss);
                                if(isSelectAllVal === true){ // isSelecAll = true: set new records as checked...
                                    selectedRowsArr.push(item.message_group_id);     
                                }
                                
                            })
                        
                            const totalRecords = response.data.total_elements;
                            this.setState({status:200, isDataLoading: true, importantHandleArr:[], tableRecords:{
                                selectedRows:[...selectedRowsArr],
                                tableData:{data:updateTableData,status:200},
                                tableHead:[],
                                isSelectAll:isSelectAllVal,
                                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords, page:nextPage, messageGroupId:''}                                
                            }});
                        }
                        
                        let rowData = updateTableData;
                        let currentMailRowId = this.state.currentMailRowId;
                        if(rowData.length > 0){

                            if(page === 0 && currentMailRowId===''){ // load default first message with page 0 and no message click on listing...
                                this.messageClickHandler(this.state.emailName, rowData[0].itemData);                                
                            }else{
                                let findRowIndex = updateTableData.findIndex(obj => obj.message_group_id === currentMailRowId);                                 
                                if(findRowIndex!=='' && findRowIndex!==null && rowData[findRowIndex]) {
                                    this.messageClickHandler(this.state.emailName, rowData[findRowIndex].itemData);    
                                }else {
                                    this.messageClickHandler(this.state.emailName, '');
                                }                               
                            }
                            
                        }else{
                            this.messageClickHandler(this.state.emailName, '')
                        }
                        
                        //console.log(this.state.tableRecords.isSelectAll,'updateState.tableRecords.isSelectAll')

                    }else{
                        this.props.Loader(false);
                        if(page === 0){
                            this.messageClickHandler(this.state.emailName, '');                            
                            const totalRecords = 0;//response.data.totalElements;
                            this.setState({status:200, isDataLoading: true, importantHandleArr:[], tableRecords:{
                                selectedRows:[],
                                tableData:[],
                                tableHead:[], 
                                isSelectAll:this.state.tableRecords.isSelectAll,                               
                                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords,messageGroupId:''}                                
                            }});    
                        }else{
                            let updateTableData = this.state.tableRecords.tableData;
                            if(updateTableData.data){
                                updateTableData = this.state.tableRecords.tableData.data;  
                            }else{
                                updateTableData = this.state.tableRecords.tableData;   
                            }
                            let rowData = updateTableData;
                            let currentMailRowId = this.state.currentMailRowId;
                            if(currentMailRowId===''){ // load default first message with page 0 and no message click on listing...
                                this.messageClickHandler(this.state.emailName, rowData[0].itemData);
                            }else{
                                let findRowIndex = updateTableData.findIndex(obj => obj.message_group_id === currentMailRowId); 
                                if(findRowIndex && rowData[findRowIndex] && rowData[findRowIndex].itemData) {
                                    this.messageClickHandler(this.state.emailName, rowData[findRowIndex].itemData);
                                }  
                            }
                                
                        }                       
                    }
                }else{
                    this.props.Loader(false);
                    const totalRecords = 0;//response.data.totalElements;
                    this.setState({status:200, isDataLoading: true, importantHandleArr:[], tableRecords:{
                        selectedRows:[],
                        tableData:[],
                        tableHead:[],
                        pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords,messageGroupId:''},                        
                    }});
                }
            }else{
                this.props.Loader(false);
                this.setState({isDataLoading:true})
                this.props.failMessage('Something went wrong!!!');    
            }
        },(error) => {
            this.props.Loader(false);
            //if(loadtype!==0) { this.props.Loader(); }
            this.props.failMessage('Something wrong on Message Listing!!!');
            console.log(error);
        })

    }

    getInboxMsgCount = () => {
        const userID = getUserInfo().data.id;
        callGET('email/message/count?emailConfigId='+this.state.emailConfigId)
        .then(response => {
            const responseData = response.data;
            // console.log(responseData);
            if(responseData.code===200){
                const updateState = {...this.state}
                updateState.msgUnreadCnt = responseData.data;
                this.setState(updateState);
            }else{
            }
        })
        .catch(err => {
            console.log(err);
            this.props.failMessage('Something went wrong');
        });
    }

    deleteMessageHandlerAlone = (mailData) => {
        console.log(mailData)
        const tableDataSel = this.state.tableRecords;
        let selectedRows = tableDataSel.selectedRows;
        selectedRows.push(mailData.message_group_id);
        //console.log(this.state.tableRecords, 'sssss')
        this.deleteMessageHandler();
    }

    deleteMessageHandler = () => {  
        this.toggleConfirmBox()            
    }

    changePlaceHolderHandler = (isCfrm) => {
        let cfrm = isCfrm
        if(cfrm===true){
            this.props.Loader();
            let body = ''
            let selectedRows = this.state.tableRecords.selectedRows;
            if(selectedRows.length>0){
                body = this.state.tableRecords.selectedRows;            
            }
            callPOST('email/messages/update?trash=true', body)
            .then((response) => {
                this.props.Loader();
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {                                            
                    this.props.succMessage(responseData.message);
                    const updateState = { ...this.state };                                                
                    updateState.tableRecords.selectedRows = []
                    updateState.tableRecords.tableData = []
                    updateState.tableRecords.tableHead = []
                    updateState.tableRecords.pagination.page = 0;
                    updateState.tableRecords.pagination.totalRecords = 0;
                    updateState.currentMailRowId = '';
                    this.setState(updateState);
                    this.emailMessageList(this.state.tableRecords.pagination);
                }else {                    
                    this.props.failMessage(responseData.message);
                }                    
            }, (error) => {
                this.props.Loader();
                this.props.failMessage('Error occured while on operation');
                console.log(error);
            });
        }
    }

    confirmButtonClick = () =>{
        let emailPage = this.state.emailName; 
        if(emailPage === 'trash'){
            this.callPermanentDelete(true);
        }else{
            this.changePlaceHolderHandler(true) 
        }         
        this.toggleConfirmBox()
    }

    toggleConfirmBox = () =>{
        const newState = {...this.state}
        newState.isConfirmBoxOpen = !this.state.isConfirmBoxOpen
        this.setState(newState)
    }

    callPermanentDelete = (isCfrm) => {
        let cfrm = isCfrm
        if(cfrm===true){
        this.props.Loader();
        let body = ''
        let selectedRows = this.state.tableRecords.selectedRows;
        if(selectedRows.length>0){
            body = this.state.tableRecords.selectedRows;            
        }
        callDELETE('email/message/delete/?moveToTrash=false&trash=false', body)
            .then((response) => {
                this.props.Loader();
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {                                            
                    this.props.succMessage(responseData.message);
                    const updateState = { ...this.state };                                                
                    updateState.tableRecords.selectedRows = []
                    updateState.tableRecords.tableData = []
                    updateState.tableRecords.tableHead = []
                    updateState.tableRecords.pagination.page = 0;
                    updateState.tableRecords.pagination.totalRecords = 0;
                    updateState.currentMailRowId = '';
                    this.setState(updateState);
                    this.emailMessageList(this.state.tableRecords.pagination);
                }else {                    
                    this.props.failMessage(responseData.message);
                }                    
            }, (error) => {
                this.props.Loader();
                this.props.failMessage('Error occured while delete message');
                console.log(error);
            });
        }    
    }

    checkBoxOnChangeHandler = (descriptorId, isChecked, message_group_id,isImpotant) => {
        //console.log(isImpotant,'isImpotant')

        let importantArr = this.state.importantHandleArr;
        let importantVal = 0;
        if(isImpotant === true){
            importantVal = 1;
        }else{
            importantVal = 0;
        }
        
        const tableDataSel = this.state.tableRecords;
        tableDataSel.tableData.data.map((item,index)=>{
        if(item.itemData.message_group_id===message_group_id){          
          if(!isChecked===true){
            let selectedRows = tableDataSel.selectedRows;
            selectedRows.push(message_group_id);
            //if(importantArr.indexOf(importantVal) === -1){
                importantArr.push(importantVal);
            //}
          }else{

            let indexIm = importantArr.indexOf(importantVal);
            if (indexIm !== -1) {
                importantArr.splice(indexIm, 1);
                
            }

            tableDataSel.selectedRows = tableDataSel.selectedRows.filter((selRows,selIndex)=>{
                if(message_group_id!== selRows){
                    return selRows;
                }
            })
          }
          
        }
      })

      //console.log(importantArr,'importantArr')

      this.setState({tableRecords:{
        ...tableDataSel,
        isSelectAll:false
      },importantHandleArr:importantArr})
        
    }

    clearOrSelectAllRows = (selectedRows,isSelectAll) => {
        const tableDataSel = this.state.tableRecords;

        // tableDataSel.tableData.data.map((item,index)=>{
        // if(!isSelectAll===true){
        //     if(selectedRows.indexOf(item.rowId) !== -1){
        //     }else{
        //         selectedRows.push(item.rowId);
        //     }
        // }
        // });

        let updatedSelectedRows = [];
        if(tableDataSel.tableData.data){
            tableDataSel.tableData.data.map((item,index)=>{
              if(!isSelectAll===true){
                  if(updatedSelectedRows.indexOf(item.itemData.message_group_id) !== -1){
                  }else{
                    updatedSelectedRows.push(item.itemData.message_group_id);
                  }
              }
            });
            
            this.setState({tableRecords:{
                ...tableDataSel,
                selectedRows:updatedSelectedRows,
                isSelectAll:!isSelectAll
            }})     
        }
           
    }

    searchFilterHandler = (event) => {
        const { name, value, options, selectedIndex } = event.target;
        const updateState = { ...this.state };        
        updateState.tableRecords.pagination.search= value;
        updateState.tableRecords.pagination.page= 0;
        updateState.currentMailRowId = '';                     
        this.setState(updateState);  
        this.emailMessageList(updateState.tableRecords.pagination);
        if(value!=='' && value!==null){
            
        }        

    }

    filterHander = (filterVal) => {
        const updateState = { ...this.state };        
        updateState.tableRecords.pagination.orderBy= filterVal;                        
        this.setState(updateState); 
        this.emailMessageList(this.state.tableRecords.pagination);
           
    }    

    assignAttachments = (mailData) => {
        let fileIds = '';
        if(mailData.attachment_file_ids) {
            fileIds = mailData.attachment_file_ids.map( (a, i) => `&ids=${a = a.replace(/\s/g, '') }`).join('');
        }
        let APIURL = 'files/search?metatableId='+fileIds;
        callGET(APIURL)
        .then(response => {
            const responseData = response.data;
            //console.log(JSON.stringify(responseData.data + 'file list aPI'))
            if(responseData.code===200){
                let filesArr = [];
                if(responseData.data!==null){
                    responseData.data.map((fileItem, index) => {
                        filesArr.push({
                            id:fileItem.id,
                            value:fileItem.id,
                            checked:null,
                            file:fileItem,
                            label:fileItem.name,
                            size:fileItem.size
                        });       
                    });
                    this.setState({files:filesArr});
                }else{
                    this.setState({files:[]});
                }                    

            }else{
                this.setState({files:[]});
            }
        })
        .catch(err => {
            // if(err.response){
            //     this.props.failMessage(err.response.data.message);                
            // }else {
            //     this.props.failMessage('Something went wrong');
            // }
        });
    }

    assignAttachments1 = (data) => {
        if(data) {
            data.map((mailData,ind) => {
                let fileIds = '';
                if(mailData.attachment_file_ids && mailData.attachment_file_ids !== '') {
                    fileIds = mailData.attachment_file_ids.map( (a, i) => `&ids=${a = a.replace(/\s/g, '') }`).join('');

                    let APIURL = 'files/search?metatableId='+fileIds;
                    callGET(APIURL)
                    .then(response => {
                        const responseData = response.data;
                        let filesD = [];
                        if(responseData.code===200){
                            let filesArr = [];
                            if(responseData.data!==null){
                                responseData.data.map((fileItem, index) => {
                                    filesArr.push({
                                        id:fileItem.id,
                                        value:fileItem.id,
                                        checked:null,
                                        file:fileItem,
                                        label:fileItem.name,
                                        size:fileItem.size
                                    });       
                                });
                                filesD = filesArr;
                                // this.setState({files:filesArr});
                            }                   
                        }
                        const updateState = {...this.state}
                        updateState.mailData[ind]['files'] = filesD;
                        this.setState(updateState);
                    })
                    .catch(err => {
                       console.log(err);
                    });
                }
            })
        }
        
    }

    getMessageData = (emailPage, mailData) => {
        callGET("email/message/"+mailData.message_group_id+"/view")
        .then(response => {
            const responseData = response.data;
            if(responseData.code===200){
                const updateState = { ...this.state };        
                updateState.pageType= 'View'; 
                responseData.data.map(mail=>{
                    console.log("mail",mail.body);
                    if(mail.body!==undefined){
                        mail.body = updateImageSources(mail.body);
                    }
                });
                updateState.mailData = responseData.data;           
                this.setState(updateState);
                // if(mailData.attachment_file_ids){
                //     if(mailData.attachment_file_ids !== '') {
                        this.assignAttachments1(responseData.data);    
                //     }
                // }
                this.props.history.push("/email-settings/email/"+emailPage+"/view");
            }else{
                
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    messageClickHandler = (emailPage, mailData, fromList=false,isClick=0) => {
        if(emailPage === 'drafts'){   
            if(fromList === true) {
                const updateState = { ...this.state };                    
                updateState.mailData = mailData;
                updateState.isComposeMail = true;           
                updateState.isDraft = true;
                updateState.showDetailedMessage = [0];                     
                updateState.currentMailRowId = mailData.message_group_id; 
                updateState.isMobileWebMessageView = false;
                if(this.state.isMobileWebView === true && isClick === 1){
                    updateState.isMobileWebMessageView = true;
                }                    
                this.setState(updateState);         
                // this.assignDraftHandler(mailData);
            }else{
                const updateState = { ...this.state };                    
                updateState.mailData = mailData; 
                updateState.showDetailedMessage = [0];
                updateState.currentMailRowId = mailData.message_group_id;  
                this.setState(updateState);  
            }
            this.getMessageData(emailPage, mailData);
            if(mailData.read && mailData.read === true) {
                return false;
            }
            this.updateMessageReadHander(mailData);
            // this.setState({showDetailedMessage: [0], currentMailRowId:mailData.message_group_id, isDraft: true})
        }else{
            //console.log(mailData.read)
            this.getMessageData(emailPage, mailData);
            const updateState = { ...this.state };                    
            updateState.showDetailedMessage = [0];                     
            updateState.currentMailRowId = mailData.message_group_id;  
            updateState.isMobileWebMessageView = false;
            if(this.state.isMobileWebView === true && isClick === 1){
                updateState.isMobileWebMessageView = true;
            } 

            // set reply to data empty and close
            // updateState.isReplyToMail = true;
            // updateState.isDraft = false;
            // updateState.isReplyTo = false;
            // updateState.replyToData = null;
            // updateState.dummyState=!this.state.dummyState;
            
            updateState.isReplyToMail = false;
            updateState.isDraft = false;
            updateState.isReplyTo = true;
            updateState.replyToData = null;
            updateState.replyMessageClose = true;
            updateState.dummyState=!this.state.dummyState;
            this.setState(updateState);
            //this.setState({showDetailedMessage: [0], currentMailRowId:mailData.message_group_id})
            /*const updateState = { ...this.state };        
            updateState.pageType= 'View'; 
            updateState.mailData = mailData;           
            this.setState(updateState);
            if(mailData.attachment_file_ids){
                if(mailData.attachment_file_ids !== '') {
                    this.assignAttachments(mailData);    
                }
            }
            this.props.history.push("/email-settings/email/"+emailPage+"/view");*/
            //this.viewMessageHandler();
            if(mailData.read && mailData.read === true) {
                return false;
            }            
            

            this.updateMessageReadHander(mailData);

            
        }
    }

    updateMessageReadHander = (mailData) => {
        let body = ''
        let selectedRows = [];
        selectedRows.push(mailData.message_group_id);
        if(selectedRows.length>0){
            body = selectedRows;            
        }
        callPOST('email/messages/update?read=true', body)
        .then((response) => {
            //this.props.Loader();
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {                                            
                //this.props.succMessage(responseData.message);
                //this.emailMessageList(this.state.tableRecords.pagination);

                let updateTableData = this.state.tableRecords.tableData;
                if(updateTableData.data){
                    updateTableData = this.state.tableRecords.tableData.data;  
                }else{
                    updateTableData = this.state.tableRecords.tableData;   
                }

                //let mailListData = this.state.tableRecords.tableData.data;
                if(updateTableData.length>0){
                    let findRowIndex = updateTableData.findIndex(obj => obj.message_group_id === mailData.message_group_id);
                    const updateState = {...this.state }
                    console.log(findRowIndex, 'findRowIndexfindRowIndex')
                    if(findRowIndex!=='' && findRowIndex!==null && updateState.tableRecords.tableData.data[findRowIndex]) {
                        
                        updateState.tableRecords.tableData.data[findRowIndex].itemData.read=true;
                        this.setState(updateState);
                    }
                }                        
                this.getInboxMsgCount();
                //this.messageClickHandler(this.state.emailName, rowData[findRowIndex].itemData); 


            }else {                    
                this.props.failMessage(responseData.message);
            }                    
        }, (error) => {
            //this.props.Loader();
            //this.props.failMessage('Error occured while on operation');
            console.log(error);
        });      
    }

    viewMessageHandler = () => {
        let mailData = this.state.mailData;
    }

    withSelectedHandler = (status, actionType, rowIndex = null) => {
        this.props.Loader();
        let body = []
        let selectedRows = this.state.tableRecords.selectedRows;
        if(rowIndex !== null && rowIndex !== undefined){
            body = [`${this.state.tableRecords.tableData.data[rowIndex].message_group_id}`]
        }
        else if(selectedRows.length>0){
            body = this.state.tableRecords.selectedRows; 
        }
        let URL = 'email/messages/update?'+actionType+'='+status;
        // if(actionType === 'archive') {
        //     URL = 'email/messages/update?archive=true';
        // }
        callPOST(URL, body)
            .then((response) => {
                this.props.Loader();
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {                                            
                    this.props.succMessage(responseData.message);

                    const updateState = { ...this.state };                                                
                    updateState.tableRecords.selectedRows = []
                    updateState.tableRecords.tableData = []
                    updateState.tableRecords.tableHead = []
                    updateState.tableRecords.pagination.page = 0;
                    updateState.tableRecords.pagination.totalRecords = 0;
                    this.setState(updateState);

                    this.emailMessageList(this.state.tableRecords.pagination);
                }else {                    
                    this.props.failMessage(responseData.message);
                }                    
            }, (error) => {
                this.props.Loader();
                this.props.failMessage('Error occured while on operation');
                console.log(error);
            });   
    }

    /**********************/    
    
    callDownloadImgFile = (e,itemFile) => {
        document.location.href = parameterizedURLAccessToken('files/download?fileId='+itemFile.id);
    }

    changeHandler = (e, emailConfigName,emailConfigId) => {
        const {name,value} = e.target;
        let activeEmail =null ;
        if(emailConfigId!==undefined && emailConfigName!==undefined){
            activeEmail = {
                "name":emailConfigName,
                "id":emailConfigId
            };
            setActiveEmail(activeEmail);
        }
        const updateState = {...this.state}
        updateState[name] = value;
        updateState['emailConfigName'] = emailConfigName;
        updateState['isFilterOpen'] = false;
        //updateState.pageType= 'Listing';
        this.setState(updateState);
        setTimeout(() => {
            //this.emailMessageList(this.state.tableRecords.pagination);
            this.callEmailPage(this.props.match.params.emailName);
        },500)
    }

    refreshHandler = () => {
        const updateState = { ...this.state };        
        updateState.tableRecords.pagination.search= '';
        updateState.tableRecords.pagination.page= 0; 
        updateState.currentMailRowId = '';
        let updatedEmailConfig = [...this.props.emailConfigList];
        updatedEmailConfig = isSet(updatedEmailConfig,[]).map(item=>{
            if(item.id===this.state.emailConfigId){
                item.sync_status = "INPROGRESS";
                item.sync_message = "email syncing inprocess please wait";
            }
            return item;
        })                                       
        this.setState(updateState);  
        this.emailMessageList(updateState.tableRecords.pagination,true);
        // this.emailMessageList(this.state.tableRecords.pagination,true);   
    }

    defaultOnclickHandler = () =>{

    }

    showDivMessageHandler = (Div_id) => {
        //showDetailedMessage 
        let showDetailedMessage = this.state.showDetailedMessage;   
        if(showDetailedMessage.indexOf(Div_id) > -1){ // Remove
            this.state.showDetailedMessage.splice(this.state.showDetailedMessage.indexOf(Div_id), 1);

        }else{ // Add
            showDetailedMessage.push(Div_id)
        }

        this.setState({showDetailedMessage: showDetailedMessage});
    }

    searchConfigFilterHandler = (event) => {
        const { name, value, options, selectedIndex } = event.target;
        const updateState = { ...this.state };        
        updateState.emailConfigSearch = value;                           
        this.setState(updateState);
        setTimeout(() => {
            this.emailConfigList('yes');                               
        },500)          
        if(value!=='' && value!==null){
            
        }        

    }

    render () {

        const { toUsers, ccUsers, isComposeMail, isDraft, isReplyToMail,isMobileWebView } = this.state;
        const {emailConfigList}= this.props;
        let ConfigList =emailConfigList
        // BreadCrumbs
        const breadCrumbs =  {
	        backHistory : [{
	        href : "/settings",
	        name:"Settings"
	        }],
	        pageTitle:"Email",
	        buttonList:[
                // {
                //     href:"",
                //     attributes:{
                //     className:"btn border-default btn-border mr-2"
                //     },
                //     name:"Email",
                //     type:"email",
                //     //clickHandler: this.callWindowNew.bind(),          
                // },
                // {
                //     href:"",
                //     attributes:{
                //     className:"btn primary_bg"
                //     },
                //     name:"Edit",
                //     type:"user",
                //     //clickHandler: this.callWindowNew.bind(),          
                // }
            ]
	    }

        //HEADER TABS
	    const headerTabs =  [{
            name:"Email",
            attributes:{
                "aria-selected":true,
                className:"nav-link active show"
            },
            href:"/email-settings/email/inbox",
          },
          {
            name:"Email Template",
            attributes:{
                "aria-selected":false,
                className:"nav-link"
            },
            href:"/email-settings/email-template",
          },

        {
	        name:"Email Setup",
	        attributes:{
	            "aria-selected":false,
	            className:"nav-link"
	        },
	        href:"/email-settings/sync-setup",
	      },
          {
            name:"Email to Data",
            attributes:{
                "aria-selected":false,
                className:"nav-link"
            },
            href:"/email-settings/email-to-data",
          },
          {
            name:"Email Timeline",
            attributes:{
                "aria-selected":false,
                className:"nav-link"
            },
            href:"/email-settings/email-timeline",
          }]

        let headerTabsCount = headerTabs.length; 
        const headerTabsList = headerTabs.map((item, i) => {
            const href = (item.href) ? item.href: "#";
            const eventsHandler = {
              onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
             }
             const style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
             let liClassName = ['nav-item'];
             if(item.liClass){
               liClassName.push(item.liClass);
             }

             let filterDiv = '';
             if(headerTabsCount === (i + 1) && this.state.emailConfigName!=''){
                filterDiv = <div className="d-inline-flex sortingTag ml-5 align-items-center badge"><span className="mr-2 text-info"> Filtered by : </span><span className="sortTag pr-2 mb-0" style={{"lineHeight":"initial","fontSize":"11px"}}> {this.state.emailConfigName}  <span data-role="remove"></span> </span></div> 
             }

             return(
                <>
                    <li className={(liClassName).join(' ')} key={i}>
                    <LinkContainer to={href} {...eventsHandler} style={style}>
                      <a   data-toggle="tab11"  role="tab" 
                      {...item.attributes} key={i} 
                        style={style} >
                            {item.name}
                      </a>
                    </LinkContainer>
                    </li>                    
                </>
             )
  
             
        });
        const UL = 'ul';
        const hideClass = " d-sm-none d-md-none d-lg-block d-none";
        return(
            <Wrp>
				<BreadCrumbs breadCrumbsList={breadCrumbs} />
                <UL className="nav nav-pills navcrm-primary nav-pills-no-bd fixed-2">
                    {headerTabsList}                                     
                </UL>
                <div className="viewport">
					

					<div className={"view view-xl"+hideClass}  id="scrollId">                        
                       
                    </div>

                    <div className="outerPort d-flex">

                        <MailLeftNav 
                          {...this.state} 
                          toggleModelHandler={(this.state.isParamWindow === true) ? this.composeMailHandler: this.composeMailHandler}
                          tableRecords={this.state.tableRecords}
                          changeHandler={this.changeHandler}
                          toggleFilter={this.toggleFilter}
                          toggleMobileWebMenu={this.toggleMobileWebMenu}
                        />

                            <MailContent
                            {...this.state}
                            toggleModelHandler={(this.state.isParamWindow === true) ? this.composeMailHandler: this.composeMailHandler}
                            toggleFilter={this.toggleFilter}
                            changeHandler={this.changeHandler}
                            callEmailPage={this.callEmailPage} 
                            tableRecords={this.state.tableRecords} 
                            recordsChangeHandler={this.emailMessageList}
                            checkBoxOnChangeHandler={this.checkBoxOnChangeHandler}
                            clearOrSelectAllRows={this.clearOrSelectAllRows}
                            deleteMessageHandler={this.deleteMessageHandler}
                            searchFilterHandler={this.searchFilterHandler}
                            filterHander={this.filterHander}
                            messageClickHandler={this.messageClickHandler}
                            withSelectedHandler={this.withSelectedHandler}
                            callDownloadImgFile={this.callDownloadImgFile}
                            composePage="main"
                            isComposeMail={isReplyToMail}
                            isDraft={isDraft}
                            replyMessageClose={this.state.replyMessageClose}
                            replyToMailHandler={this.replyToMailHandler}
                            emailMessageList={this.emailMessageList}
                            mailData={this.state.mailData} 
                            isReplyTo={this.state.isReplyTo}
                            replyToData={this.state.replyToData}
                            replyToMailHandlerCallback={this.replyToMailHandlerCallback}
                            refreshHandler={this.refreshHandler}
                            showDivMessageHandler={this.showDivMessageHandler}
                            searchConfigFilterHandler={this.searchConfigFilterHandler}
                            deleteMessageHandlerAlone={this.deleteMessageHandlerAlone}
                            toggleMobileWebMenu={this.toggleMobileWebMenu}
                            emailConfigList={ConfigList}
                            toggleMobileWebMessageView={this.toggleMobileWebMessageView}
                            />
                    </div>


                            

                        
                    
                </div>

                

                <AssignWindow 
                {...this.state}
                formData={JSON.stringify(this.state.formFields)}                 
                addDataHandler={this.addDataHandler}
                modelOpenWindow={this.state.modalWindow} 
                createTemplateHandler={this.continueHandler} 
                toggleModelHandlerWindow={this.toggleModelHandlerWindow} 
                />

                {
                  isComposeMail === true
                  ?
                  <ComposeMail
                  composePage="main"
                  isComposeMail={isComposeMail}
                  isDraft={isDraft}
                  composeMailHandler={this.composeMailHandler}
                  emailMessageList={this.emailMessageList}
                  mailData={this.state.mailData} 
                  // isReplyTo={this.state.isReplyTo}
                  // replyToData={this.state.replyToData}
                  />
                  :
                  ''
                }
            <ConfirmBox
            isConfirmBoxOpen={this.state.isConfirmBoxOpen}
            toggleConfirmBox={this.toggleConfirmBox}
            confirmButtonClick={this.confirmButtonClick}
            content={this.state.emailName !== "trash"? "Are you sure want move to trash?" : "Are you sure want to delete permanently?"}
          />  
            </Wrp>
        )
    }
}
const mapStateToProps = (state) => { 

	return {  
	  emailConfigList:state.formBuilder.emailConfigList
	};
  }
const mapDispatchToProps = dispatch => {
    return {
      Loader : (bool) => dispatch(actions.loader(bool)),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg)),
      setEmailConfigList:(obj)=>dispatch(setEmailConfigList(obj))

    };
  }
export default
    connect(
        mapStateToProps, 
      mapDispatchToProps
    )(withRouter(EmailSetupContainer));